import * as yup from 'yup';
import { kennitalaFormat } from '../../../helpers/regex/regex';

export const userAndPassInitialValues = {};

export const userAndPassSchema = yup.object().shape({});

export const audkenniAppLoginSchema = yup.object().shape({
	ssn: yup.string()
		.matches(kennitalaFormat, 'socialId-wrong-format')
		.min(10, 'socialId-min')
		.required('socialId-required'),
});

export const audkenniAppLoginInitialValues = {
	ssn: '',
};